module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/ligne16-8a6ca85b770ab527371c145d4c466b56.png";